import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './ErrorMessage.css'
import Button from '../Button/Button'

import FormActions from '../../actions/FormActions'

const OrderAddressError = 'OrderAddressError'
const OrderNoCarsError = 'OrderNoCarsError '
const OrderPreBookingFullError = 'OrderPreBookingFullError'
const OrderPhoneNumberError = 'OrderPhoneNumberError'
const OrderPaymentPasswordIsNotStored = 'OrderPaymentPasswordIsNotStored'
const OrderPaymentWithoutUserError = 'OrderPaymentWithoutUserError'
const OrderPaymentMethodNotFound = 'OrderPaymentMethodNotFound'
const OrderCreditCardNoFundsError = 'OrderCreditCardNoFundsError'
const OrderWithoutDestinationError = 'OrderWithoutDestinationError'
const OrderCreditCardReservationError = 'OrderCreditCardReservationError'
const PriceInvalidError = 'PriceInvalidError'
const PriceExpiredError = 'PriceExpiredError'
const InternalSystemError = 'InternalSystemError'
const UnauthorizedError = 'UnauthorizedError'
const ValidationError = 'ValidationError'
// 400-1	OrderAddressError
// Departure address is unknown
//
// 400-2	OrderNoCarsError
// There are no cars available
//
// 400-3	OrderPreBookingFullError
// No more pre bookings are accepted for this date and time
//
// 400-4	OrderPhoneNumberError
// The phone number provided is not in a correct format
//
// 400-5	OrderPaymentPasswordIsNotStored
// User has a TSAB account stored, but no password is stored for it
//
// 400-6	OrderPaymentWithoutUserError
// This payment method requires user
//
// 400-7	OrderPaymentMethodNotFound
// This payment method is not found
//
// 400-8	OrderCreditCardNoFundsError
// This payment method does not have sufficient funds
//
// 400-9	OrderWithoutDestinationError
// Destination should be present (for fixed price orders)
//
// 400-10	OrderCreditCardReservationError
// Verification of a crdit card failed
//
// 400-11	PriceInvalidError
// The provided price token is invalid (different order request from the estimate request)
//
// 400-12	PriceExpiredError
// The provided price token has expired
//
// 400-13	InternalSystemError
// Internal system error
//
// 401	UnauthorizedError
// Request was not authenticated with a signed request or bearer token
//
// 422	ValidationError
// Posted order does not match required specifications (not an object, mispelled fields, missing required values etc.)
@CSSModules(styles, { allowMultiple: true })
export default class ErrorMessage extends Component {
  static propTypes = {
    errorType: PropTypes.number,
    message: PropTypes.string
  }
  static defaultProps = {
    message: '',
    errorType: null
  }
  _onClick () {
    FormActions.displayErrorMessage({ message: null, code: null })
  }
  _getImage (code) {
    switch (code) {
      case OrderAddressError:
        return 'road'
      case PriceExpiredError:
      case OrderPreBookingFullError:
        return 'time'
      case OrderNoCarsError:
      case OrderPhoneNumberError:
      case OrderPaymentPasswordIsNotStored:
      case OrderPaymentWithoutUserError:
      case OrderPaymentMethodNotFound:
      case OrderCreditCardNoFundsError:
      case OrderWithoutDestinationError:
      case OrderCreditCardReservationError:
      case PriceInvalidError:
      case InternalSystemError:
      case ValidationError:
      case UnauthorizedError:
      default:
        return 'cross'
    }
  }

  render () {
    const { errorType, message } = this.props
    if (!message) return null
    return (
      <div styleName="errorMessage">
        <div styleName="message">
          <img src={`/static/img/errors/${this._getImage(errorType)}.svg`} styleName="image" />
          <p styleName="text">{message}</p>
          <Button
            autoFocus
            onClick={this._onClick.bind(this)}
            text="Jag förstår" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.js